import { LEGACY_URL } from 'config'
import { RequestBuilder, authorizedPipe } from 'services/net'
import { PPAddOnUpdate } from 'shared/types'

export const ENDPOINT_UPGRADE_SUBSCRIPTION = `${LEGACY_URL}/subscriptions/upgrade_to/:subscription`
export const ENDPOINT_UPGRADE_SUBSCRIPTION_V2 = `${LEGACY_URL}/v3/subscription/subscription/update_subscription`
export const ENDPOINT_END_TRIAL = `${LEGACY_URL}/v3/trial_events/end_cc_trial`
export const ENDPOINT_MANAGE_ADDONS = `${LEGACY_URL}/v3/subscription/subscription/manage_addons`

export const V1 = Object.freeze({
  upgradeV2: function () {
    const builder = new RequestBuilder(ENDPOINT_UPGRADE_SUBSCRIPTION_V2).asPost().expectJSON()

    return function (handle: string) {
      return authorizedPipe<any>(
        builder.bodyJSONstringify({ product_handle: handle }).build()
      )
    }
  }(),
  endTrial: function () {
    const builder = new RequestBuilder(ENDPOINT_END_TRIAL).asPost().expectJSON()

    return function (handle: string) {
      return authorizedPipe<any>(
        builder
          .param('plan', handle)
          .build()
      )
    }
  }(),
  manageAddOns: function () {
    const builder = new RequestBuilder(ENDPOINT_MANAGE_ADDONS).asPost().expectJSON()

    return function (addons: PPAddOnUpdate[]) {
      return authorizedPipe<any>(
        builder.bodyJSONstringify({ addons }).build()
      )
    }
  }(),
  migrateToStripe: function () {
    const builder = new RequestBuilder(`${LEGACY_URL}/v3/subscription/subscription/migrate_to_stripe`).asPost().expectJSON()

    return function () {
      return authorizedPipe<any>(
        builder.build()
      )
    }
  }()
})
